import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import '../App.css';

export default function FooterControl(props) {

   const [value, setValue] = React.useState(30);
   const [prevDeltaScene, setPrevDeltaScene] = React.useState(0);
   const [zoombarValue, setZoombarValue] = React.useState(0);

   const handleChange = (event, newValue) => {
      setValue(newValue);
   };
   window.updateSlider = function(){
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }

   const handleZoomChange = (e, newValue) => {
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      // clearCalloutCanvas();
      if (e) {
         window.scene._nav.NavChangeDolly(undefined, e.target.value / 100);
      } else {
         window.scene._nav.NavChangeDolly(undefined, newValue / 100);
         document.getElementById("sliderRange").value = newValue;
      }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.hidePopUp();

      if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
         window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
         window.handleZoomoutCam(window.zoomOutSequence)
         
      }
       if (e) {
         window.scene._nav.NavChangeDolly(undefined,e.target.value / 100);
      } else {
         window.scene._nav.NavChangeDolly(undefined,newValue / 100);
         document.getElementById("sliderRange").value = newValue;
      }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }

      window.hidePopUp();

      window.updateSlider();
   };
   const [camData, setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;

   const onZoomIn = (e) => {
      window.clearCalloutCanvas();
      if (window.scene._nav.getZoomFactor() > 0)
         handleZoomChange(null, -1 + (parseFloat(document.getElementById("sliderRange").value)))

         if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
            window.zoonOutCamStatus = false;
      
            // this code is used to hide pop on mouse down
            var allPopup = document.querySelector('.popup.active');
            if (allPopup != null) {
               allPopup.classList.remove('active');
            }
            window.handleZoomoutCam(window.zoomOutSequence)
         }
         
   }
   const onZoomOut = (e) => {
      window.clearCalloutCanvas();
      if (window.scene._nav.getZoomFactor() < 100)
         handleZoomChange(null, 1 + (parseFloat(document.getElementById("sliderRange").value)))

         if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
            window.zoonOutCamStatus = false;
      
            // this code is used to hide pop on mouse down
            var allPopup = document.querySelector('.popup.active');
            if (allPopup != null) {
               allPopup.classList.remove('active');
            }
               window.handleZoomoutCam(window.zoomOutSequence)
         }
         

         
   }
   const onLeft = () => {
      window.clearCalloutCanvas();
      window.scene._nav.NavRotation([0, 0], [7, 0]);
      
      window.hidePopUp();
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.scene.clearRefine();
      if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
         window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
         window.handleZoomoutCam(window.zoomOutSequence)
      }
   }
   const onRight = () => {
      window.clearCalloutCanvas();
      window.scene._nav.NavRotation([0, 0], [-7, 0]);
      window.hidePopUp();
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.scene.clearRefine();
      if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
         window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
         window.handleZoomoutCam(window.zoomOutSequence)
      }
   }

   let { previousView,resetView,nextView } = { ...props.data };

   return (
      <React.Fragment>
         {ReactDOM.createPortal(
            <div id='footerControls' className="footerControlsDesk">
               <div className="threebtns">
                  <div className="zoombarandRotateContainer">

                     <div className='topbtns'  >
                        <button className='navBtn footerBtn floatleft' aria-label="Rotate Left" id="rLeft" tabIndex="-1" onClick={onLeft} title="left">
                           <img alt="Rotate left" src="./images/diagonalLeftArrow.svg" />
                        </button>
                        <button className='navBtn footerBtn' aria-label="Rotate Right" id="rRight" tabIndex="-1" onClick={onRight} title="right">
                           <img alt="Rotate right" src="./images/diagonalRightArrow.svg" />
                        </button>
                     </div>

                     <div id="zoomSliderContainer " className='zoombar'>
                        <img style={{ height: '100%' }} alt="zoombar" aria-hidden="true" src="./images/ZOOMBAR.svg" />

                        <button tabIndex="-1" className='navBtn MuiButtonBase-root MuiButton-root MuiButton-text' style={{ color: "#0076CE" }} type="button" aria-label="Clickable Zoom Out" role="button" id="zoomIn" onClick={onZoomIn}> </button>
                        <div id="zoomSlider" aria-hidden="true">
                           <div className="rangeslider" aria-hidden="true">
                              <label> <input tabIndex="-1" aria-hidden="true" type="range" min="0" max="100" step="1" className="myslider" onChange={handleZoomChange} id="sliderRange" />
                              </label>
                           </div>
                        </div>
                        <button className='navBtn MuiButtonBase-root MuiButton-root MuiButton-text' tabIndex="-1" style={{ color: "#0076CE" }} type="button" id="zoomOut" role="button" aria-label="Clickable Zoom In" onClick={onZoomOut}></button>
                     </div>
                  </div>
                  <div className='clearBoth' >
                     <button tabIndex="-1" className='navBtn threeButtons' aria-label="Previous view" id="previousView" variant="outlined" color="primary" onClick={e=>props.onPrevious(e)} >
                        <div style={{ display: 'inline-block',verticalAlign: 'middle' }}>
                           <img alt="Previous view" src="./images/leftArrow.svg" style={{ height: '20px', width: '24px', verticalAlign: 'middle'  }}/>
                        </div>
                        <div style={{ display: 'inline-block',verticalAlign: 'middle',width: 'calc(100% - 34px)',boxSizing: 'border-box',paddingLeft: '5px' }}>
                           {previousView !== undefined ? previousView : 'Previous View'}
                        </div>
                     </button>
                     <button tabIndex="-1" className='navBtn threeButtons' variant="outlined" id="resetView" color="primary" onClick={e=>props.onReset(e)} >
                        {resetView !== undefined ? resetView : 'Reset View'}
                     </button>
                     <button tabIndex="-1" className='navBtn threeButtons' aria-label="Next view" id="nextView" variant="outlined" color="primary" onClick={e=>props.onNext(e)} expanded={props.expanded} >
                        <div style={{ display: 'inline-block',verticalAlign: 'middle',width: 'calc(100% - 34px)',boxSizing: 'border-box',paddingLeft: '5px' }}>
                           {nextView !== undefined ? nextView : 'Next View'}
                        </div>
                        <div style={{ display: 'inline-block', verticalAlign:'middle'}}>
                           <img alt="Next view" src="./images/rightArrow.svg" style={{ height: '20px', width: '24px', verticalAlign: 'middle'  }} />
                        </div>
                     </button>
                  </div>
               </div>
            </div>,document.getElementById('footerControlDesk')
         )}
      </React.Fragment>

   );
}
